<template>
  <el-dialog
    top="60px"
    width="680px"
    class="rating-form"
    :title="!isEdit ? 'Thêm mới đánh giá' : 'Chỉnh sửa đánh giá'"
    :visible="visible"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" label-position="top" :rules="rules">
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="Loại địa điểm" prop="place_type">
            <el-select
              v-model="form.place_type"
              class="w-100"
              filterable
              placeholder="Chọn loại địa điểm"
              :disabled="!!object"
              @change="handleChangePlaceType"
            >
              <el-option
                v-for="item in placeTypes"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Địa điểm" prop="place_id">
            <el-select
              v-model="form.place_id"
              class="w-100"
              filterable
              remote
              placeholder="Chọn địa điểm"
              :disabled="!!object"
              :remote-method="searchPlaces"
              :loading="searchingPlaces"
            >
              <el-option
                v-for="p in places"
                :key="p.id"
                :label="p.name"
                :value="p.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="Nguồn" prop="origin">
            <el-select v-model="form.origin" class="w-100" placeholder="Chọn nguồn" @change="handleOriginChange">
              <el-option label="Google" value="google">
                <i class="fab fa-google mr-1"></i> Google
              </el-option>
              <el-option label="Booking" value="booking">
                <i class="fas fa-hotel mr-1"></i> Booking
              </el-option>
              <el-option label="Hội đồng đánh giá" value="council">
                <i class="fas fa-award mr-1"></i> Hội đồng đánh giá
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Thứ tự (Ordered)" prop="ordered">
            <el-input-number v-model="form.ordered" :min="0" class="w-100" controls-position="right"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="External ID" prop="external_id">
        <el-input v-model="form.external_id" placeholder="Nhập External ID" @blur="handleAutoSyncIfEmpty"></el-input>
      </el-form-item>

      <el-form-item label="Source URL" prop="source_url">
        <el-input v-model="form.source_url" placeholder="Nhập Link nguồn (https://maps.google.com/...)" @blur="handleAutoSyncIfEmpty">
          <el-button slot="append" icon="el-icon-refresh" type="primary" @click="handleSyncRating">
            Sync Data
          </el-button>
        </el-input>
      </el-form-item>

      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="Điểm đánh giá" prop="rating">
            <div v-if="isGoogleOrigin" class="rating-input-wrapper">
              <el-rate
                v-model="form.rating"
                allow-half
                show-score
                text-color="#ff9900"
                score-template="{value}"
                :max="5"
              ></el-rate>
              <el-input-number
                v-model="form.rating"
                :min="0"
                :max="5"
                :step="0.1"
                :precision="1"
                size="small"
                class="ml-2"
                controls-position="right"
              ></el-input-number>
            </div>
            <div v-else>
              <el-input-number
                v-model="form.rating"
                :min="0"
                :max="10"
                :step="0.1"
                :precision="1"
                class="w-100"
                controls-position="right"
                placeholder="Nhập điểm đánh giá (tối đa 10)"
              ></el-input-number>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Số Reviews" prop="helpful_votes">
            <el-input-number v-model="form.helpful_votes" :min="0" class="w-100" controls-position="right"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="16">
        <!-- <el-col :span="12">
          <el-form-item label="Tên tác giả" prop="author_name">
            <el-input v-model="form.author_name" placeholder="Nhập tên tác giả"></el-input>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="24">
          <el-form-item label="Ngày đánh giá" prop="rated_at">
            <el-date-picker
              v-model="form.rated_at"
              type="date"
              placeholder="Chọn ngày đánh giá"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd HH:mm:ss"
              class="w-100"
            ></el-date-picker>
          </el-form-item>
        </el-col> -->
      </el-row>

      <!-- <el-form-item label="Avatar URL tác giả" prop="author_avatar_url">
        <el-input v-model="form.author_avatar_url" placeholder="https://lh3.googleusercontent.com/..."></el-input>
        <div v-if="form.author_avatar_url" class="mt-2 avatar-preview">
          <el-avatar :size="40" :src="form.author_avatar_url"></el-avatar>
        </div>
      </el-form-item> -->

      <!-- <el-form-item label="Tiêu đề bài đánh giá (Name)" prop="name">
        <el-input v-model="form.name" placeholder="Nhập tiêu đề đánh giá"></el-input>
      </el-form-item> -->

      <!-- <el-form-item label="Nội dung bài đánh giá (Content)" prop="content">
        <el-input v-model="form.content" type="textarea" :rows="3" placeholder="Nhập nội dung chi tiết đánh giá"></el-input>
      </el-form-item> -->
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button :disabled="callingAPI" @click="handleClose">Hủy</el-button>
      <el-button type="primary" :loading="callingAPI" @click="handleUpdate">
        {{ !isEdit ? 'Tạo' : 'Cập nhật' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import { createPlaceRating, updatePlaceRating, syncRatingData } from '@/services/place-rating'
import { listPlaces, getPlaceById } from '@/services/place'
import { getPlaceTypes, getTranslation } from '@/utils/filters'

export default {
  name: 'UpdatePlaceRating',
  props: {
    ratingItem: {
      type: Object,
      default: null
    },
    object: {
      type: Object,
      default: null
    },
    visible: Boolean
  },
  data() {
    const existingTranslation = this.ratingItem && this.ratingItem.translations
      ? this.ratingItem.translations.find((t) => t.locale === (this.language || 'vi')) || this.ratingItem.translations[0]
      : null

    const initPlaceId = (this.ratingItem && this.ratingItem.place_id) || (this.object && this.object.id) || ''

    return {
      callingAPI: false,
      searchingPlaces: false,
      places: [],
      form: {
        place_type: '',
        place_id: initPlaceId,
        origin: this.ratingItem ? (this.ratingItem.origin || 'google') : 'google',
        external_id: this.ratingItem ? (this.ratingItem.external_id || '') : '',
        source_url: this.ratingItem ? (this.ratingItem.source_url || '') : '',
        rating: (this.ratingItem && this.ratingItem.rating !== undefined && this.ratingItem.rating !== null)
          ? Number(this.ratingItem.rating)
          : 5,
        helpful_votes: (this.ratingItem && this.ratingItem.extra_data && this.ratingItem.extra_data.helpful_votes !== undefined)
          ? this.ratingItem.extra_data.helpful_votes
          : 0,
        author_name: this.ratingItem ? (this.ratingItem.author_name || '') : '',
        author_avatar_url: this.ratingItem ? (this.ratingItem.author_avatar_url || '') : '',
        rated_at: this.ratingItem ? (this.ratingItem.rated_at || '') : '',
        ordered: this.ratingItem ? (this.ratingItem.ordered || 0) : 0,
        name: existingTranslation ? existingTranslation.name : (this.ratingItem ? this.ratingItem.name || '' : ''),
        content: existingTranslation ? existingTranslation.content : (this.ratingItem ? this.ratingItem.content || '' : '')
      },
      rules: {
        place_id: [
          { required: true, message: 'Địa điểm không được để trống', trigger: ['blur', 'change'] }
        ],
        origin: [
          { required: true, message: 'Nguồn không được để trống', trigger: ['blur', 'change'] }
        ],
        rating: [
          { required: true, message: 'Điểm đánh giá không được để trống', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['language']),
    isEdit() {
      return Boolean(this.ratingItem && this.ratingItem.id)
    },
    isGoogleOrigin() {
      return this.form.origin === 'google' || this.form.origin === 'gg'
    },
    maxRating() {
      return this.isGoogleOrigin ? 5 : 10
    },
    placeTypes() {
      return getPlaceTypes(false).filter((p) => p.type === 'place')
    },
    dataInput() {
      let formattedRatedAt = null
      if (this.form.rated_at) {
        if (typeof this.form.rated_at === 'string' && this.form.rated_at.includes('/')) {
          const parts = this.form.rated_at.split('/')
          if (parts.length === 3) {
            formattedRatedAt = `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')} 00:00:00`
          }
        } else {
          const d = dayjs(this.form.rated_at)
          if (d.isValid()) {
            formattedRatedAt = d.format('YYYY-MM-DD HH:mm:ss')
          }
        }
      }

      const data = {
        place_id: this.form.place_id,
        origin: this.form.origin,
        external_id: this.form.external_id,
        source_url: this.form.source_url,
        rating: Number(this.form.rating),
        author_name: this.form.author_name,
        author_avatar_url: this.form.author_avatar_url,
        rated_at: formattedRatedAt,
        ordered: this.form.ordered,
        extra_data: {
          helpful_votes: Number(this.form.helpful_votes || 0)
        },
        name: this.form.name,
        content: this.form.content,
        locale: this.language
      }
      if (this.isEdit) {
        data.id = this.ratingItem.id
      }
      return data
    }
  },
  async beforeMount() {
    if (this.form.place_id) {
      try {
        const place = await getPlaceById({ id: this.form.place_id, locale: this.language })
        if (place) {
          this.form.place_type = place.place_type
          this.places = [{
            id: place.id,
            name: place.name || (getTranslation(place, this.language) ? getTranslation(place, this.language).name : '')
          }]
        }
      } catch (e) {
        // ignore
      }
    }
  },
  methods: {
    handleOriginChange() {
      if (this.form.rating > this.maxRating) {
        this.form.rating = this.maxRating
      }
    },
    getPlaces(searchText = '') {
      this.searchingPlaces = true
      listPlaces({
        locale: this.language,
        place_types: this.form.place_type,
        per_page: 20,
        search_text: searchText
      }).then((res) => {
        this.places = (res.result || []).map((p) => ({
          id: p.id,
          name: p.name || (getTranslation(p, this.language) ? getTranslation(p, this.language).name : '')
        }))
        this.searchingPlaces = false
      }).catch(() => {
        this.searchingPlaces = false
      })
    },
    handleChangePlaceType() {
      this.form.place_id = ''
      this.places = []
      this.getPlaces()
    },
    searchPlaces(query) {
      this.getPlaces(query)
    },
    async handleSyncRating() {
      try {
        const synced = await syncRatingData({
          external_id: this.form.external_id,
          source_url: this.form.source_url,
          origin: this.form.origin
        })
        if (synced) {
          if (synced.origin) this.form.origin = synced.origin
          if (synced.external_id) this.form.external_id = synced.external_id
          if (synced.rating !== undefined && synced.rating !== null) {
            this.form.rating = Number(synced.rating)
            if (this.form.rating > this.maxRating) {
              this.form.rating = this.maxRating
            }
          }
          if (synced.extra_data && synced.extra_data.helpful_votes !== undefined) {
            this.form.helpful_votes = synced.extra_data.helpful_votes
          }
          this.$notify.success({
            title: 'Sync thành công',
            message: `Đã đồng bộ thông tin rating (${this.form.rating})`
          })
        }
      } catch (e) {
        // ignore error
      }
    },
    async handleAutoSyncIfEmpty() {
      if (this.form.external_id || this.form.source_url) {
        try {
          const synced = await syncRatingData({
            external_id: this.form.external_id,
            source_url: this.form.source_url,
            origin: this.form.origin
          })
          if (synced) {
            if (synced.origin) this.form.origin = synced.origin
            if (synced.external_id && !this.form.external_id) this.form.external_id = synced.external_id
            if (synced.rating !== undefined && synced.rating !== null) {
              this.form.rating = Number(synced.rating)
              if (this.form.rating > this.maxRating) {
                this.form.rating = this.maxRating
              }
            }
            if (synced.extra_data && synced.extra_data.helpful_votes !== undefined) {
              this.form.helpful_votes = synced.extra_data.helpful_votes
            }
          }
        } catch (e) {
          // ignore error
        }
      }
    },
    handleUpdate() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.callingAPI = true
          if (!this.isEdit) {
            createPlaceRating(this.dataInput).then(() => {
              this.$notify.success({
                title: 'Thành công',
                message: 'Tạo mới đánh giá thành công'
              })
              this.$emit('close')
              this.$emit('reload')
              this.callingAPI = false
            }).catch((err) => {
              this.callingAPI = false
              this.$notify.error({
                title: 'Lỗi',
                message: (err && err.response && err.response.data && err.response.data.message) || 'Tạo mới thất bại'
              })
            })
          } else {
            updatePlaceRating(this.dataInput).then(() => {
              this.$notify.success({
                title: 'Thành công',
                message: 'Cập nhật đánh giá thành công'
              })
              this.$emit('close')
              this.$emit('reload')
              this.callingAPI = false
            }).catch((err) => {
              this.callingAPI = false
              this.$notify.error({
                title: 'Lỗi',
                message: (err && err.response && err.response.data && err.response.data.message) || 'Cập nhật thất bại'
              })
            })
          }
        }
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.w-100 {
  width: 100%;
}
.rating-input-wrapper {
  display: flex;
  align-items: center;
}
.avatar-preview {
  display: flex;
  align-items: center;
}
</style>
